export default __webpack_public_path__ + "0734a829c65f71aef83279685541fce3.svg";